import { Navigate } from 'react-router-dom';

import { ROUTES } from '../constants/routes';
import useAdmissionEnabled from '../hooks/useAdmissionEnabled';

/**
 * AdmissionEnabledGate — gates Admission (IPD) routes behind the per-org
 * enableAdmissionModule flag. Redirects to the org home when the Admission
 * module is off, so an admission-disabled org behaves exactly as today.
 * Clone of LabEnabledGate (App.js). B1 wraps no routes yet (no IPD screens
 * exist until B2) — the component is the deliverable.
 */
export default function AdmissionEnabledGate({ children }) {
  const admissionOn = useAdmissionEnabled();
  if (!admissionOn) return <Navigate to={ROUTES.ORG} replace />;
  return children;
}
